// 个人信息默认模板
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://cn.bing.com/images/search?view=detailV2&ccid=3rQ0W4iv&id=E94363D4919EE5C5A729974F1F54D508937EF941&thid=OIP.3rQ0W4ivbnQcKt17I5ZNCgAAAA&mediaurl=https%3a%2f%2fc-ssl.dtstatic.com%2fuploads%2fblog%2f202306%2f04%2fd3S26N52IqMeglx.thumb.400_0.jpeg&exph=399&expw=400&q=%e5%8a%a8%e6%bc%ab%e5%a4%b4%e5%83%8f&FORM=IRPRST&ck=13A71EF72DF99151D2895CF589768BC2&selectedIndex=18&itb=0',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: '未设置邮箱',
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#'
};

// 导出个人信息 mock 数据
export const mockAboutInfo = defaultAboutInfoTemplate;

// ========== 核心：带点赞+多评论的固定文章 ==========
// 第一篇：“老己”是温柔的松弛（点赞12，3条评论）
const FIXED_POST_1 = {
  id: 'post_fixed_001',
  title: '“老己”是温柔的松弛',
  date: '2025/12/26',
  likeCount: 12, // 新增点赞数
  commentCount: 3, // 评论数对应comments数组长度
  tags: ['生活感悟'],
  content: `你有没有过这种时刻：
赶方案到凌晨，对着屏幕骂“怎么这么笨”；体重秤数字跳了跳，就暗戳戳和自己较劲儿；甚至只是忘了带钥匙，都要在心里把自己数落半天。

我们总习惯把“高标准”先砸向自己，却忘了——“老己”才是要陪你走最久的人。
“老己”不是敷衍的“摆烂”，是把“我必须做好”换成“今天先完成就好”；是加班晚了，别催自己“快洗漱”，而是说“坐下喝口热的，慢慢来”。

二、“加油”不必是喊口号
“加油老己”从来不是攥紧拳头的硬撑：
-是没做好的事，别抓着不放——“这次漏了细节，下次多留个心眼就好”；
-是情绪崩了的时候，别逼自己“要坚强”——“哭完这阵，咱吃点甜的缓一缓”；
-是看到别人发光时，别慌着否定自己——“他有他的花期，我也有我的节奏”。
这声“加油”，是给那个有点笨拙、偶尔疲惫的自己，递一杯热饮，拍一拍肩膀：“你已经在好好走啦，别急。”

三、好好待“老己”，是终身的事
生活的难题不会少，但“老己”是你的底气：
明天的报表可以慢慢改，没减下去的肉可以慢慢练，没说出口的话可以慢慢讲——你不用活成谁的“标准答案”，你只要是“你的版本”就够了。

所以啊，今天也和自己说句：“加油，老己。”

毕竟这人间的路，你和自己，要一起慢慢走。`,
  createTime: '2025/12/26 14:07:01',
  updateTime: '2025/12/26 14:07:01',
  // 新增多条评论
  comments: [
    {
      id: 'comment_001',
      username: 'lu-tang',
      content: '生活里的琐碎，总能戳中人心',
      createTime: '2025/12/26 14:07:30'
    },
    {
      id: 'comment_002',
      username: '晚风叙旧',
      content: '看完被治愈了，对自己温柔一点吧✨',
      createTime: '2025/12/26 15:20:18'
    },
    {
      id: 'comment_003',
      username: '山野千里',
      content: '“你的版本就够了”，这句话记下来了！',
      createTime: '2025/12/26 16:05:42'
    }
  ]
};

// 第二篇：老巷深处的月光（点赞8，2条评论）
const FIXED_POST_2 = {
  id: 'post_fixed_002',
  title: '老巷深处的月光',
  date: '2025/12/26',
  likeCount: 8, // 新增点赞数
  commentCount: 2, // 评论数对应comments数组长度
  tags: ['生活'],
  content: `一、青石板上的雨
老巷的青石板总带着潮润的凉。
小时候一下雨，我就蹲在门槛上数水花——**铜钱大的雨点儿**砸在石板凹处，溅起半指高的白，混着墙根苔藓的腥气，往鼻尖钻。

卖糖人的老头会把担子歇在巷口，竹筐上盖块蓝布，露出半只插满糖画的草把子。阿婆们端着瓷碗倚在门廊聊天，瓷碗沿磕出的缺口，盛着刚出锅的腌菜

二、木门后的光
巷尾第三家的木门，永远留道指宽的缝。
傍晚放学，我扒着门缝往里瞧：**昏黄的灯泡**悬在房梁，阿公正把竹椅往天井搬，竹椅腿磨过青砖，“吱呀”声裹着饭香飘出来。

夏夜会摆张竹床，阿婆摇着蒲扇讲狐仙的故事，肩骨蹭过我的胳膊，软乎乎的
中秋的月饼要分着吃，五仁馅的碎渣掉在青石板上，被巷口的猫舔得干净

三、月光落满归途
后来我走得越来越远，老巷成了地图上模糊的点。
前阵子回去，青石板被踩得发亮，阿婆们的瓷碗换了新的，可木门缝里漏出的光，还是当年的温度——**月光漫过巷口的墙**，像小时候阿婆盖在我身上的薄被，轻得刚好。`,
  createTime: '2025/12/26 11:56:08',
  updateTime: '2025/12/26 11:56:08',
  // 新增多条评论
  comments: [
    {
      id: 'comment_004',
      username: '城南旧事',
      content: '瞬间想起外婆家的老巷，月光也是这样的🌙',
      createTime: '2025/12/26 12:10:25'
    },
    {
      id: 'comment_005',
      username: '人间客',
      content: '文字好有画面感，仿佛闻到了老巷的烟火气',
      createTime: '2025/12/26 13:45:11'
    }
  ]
};

// 汇总所有固定文章
const ALL_FIXED_POSTS = [FIXED_POST_1, FIXED_POST_2];

// ========== 初始化逻辑：确保固定文章存在 ==========
let mockPosts = JSON.parse(localStorage.getItem('myBlogPosts')) || [];

// 遍历添加所有固定文章
ALL_FIXED_POSTS.forEach(fixedPost => {
  const isExist = mockPosts.some(post => post.id === fixedPost.id);
  if (!isExist) {
    mockPosts.unshift(fixedPost);
  }
});
localStorage.setItem('myBlogPosts', JSON.stringify(mockPosts));

// 保存文章到localStorage
const savePostsToLocal = () => {
  localStorage.setItem('myBlogPosts', JSON.stringify(mockPosts));
};

// 模拟文章接口（原有逻辑保留）
export const mockPostsApi = {
  posts: {
    getPosts: async (page, limit) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            success: true,
            data: { posts: [...mockPosts] }
          });
        }, 500);
      });
    },

    deletePost: async (postId) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const targetPostId = typeof postId === 'number' ? `post_${postId}` : postId;
          const isFixedPost = ALL_FIXED_POSTS.some(post => post.id === targetPostId);
          if (isFixedPost) {
            resolve({ success: false, message: '该公开文章不可删除' });
            return;
          }
          const postExists = mockPosts.some(post => post.id === targetPostId);
          
          if (postExists) {
            mockPosts = mockPosts.filter(post => post.id !== targetPostId);
            savePostsToLocal();
            resolve({ success: true, message: '删除成功' });
          } else {
            resolve({ success: false, message: '文章不存在，删除失败' });
          }
        }, 300);
      });
    },

    getPostById: async (postId) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const targetPostId = typeof postId === 'number' ? `post_${postId}` : postId;
          const post = mockPosts.find(p => p.id === targetPostId);
          
          if (post) {
            resolve({ success: true, data: { post } });
          } else {
            resolve({ success: false, message: '文章不存在' });
          }
        }, 300);
      });
    },

    savePost: async (postData) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const isFixedPost = ALL_FIXED_POSTS.some(post => post.id === postData.id);
          if (isFixedPost) {
            resolve({ success: false, message: '该公开文章不可编辑' });
            return;
          }
          if (postData.id) {
            mockPosts = mockPosts.map(post => 
              post.id === postData.id ? { ...post, ...postData } : post
            );
          } else {
            const newPostId = `post_${Date.now()}`;
            const newPost = {
              id: newPostId,
              date: new Date().toISOString().split('T')[0],
              likeCount: 0,
              commentCount: 0,
              ...postData
            };
            mockPosts.unshift(newPost);
          }
          savePostsToLocal();
          resolve({ success: true, message: postData.id ? '编辑成功' : '新增成功' });
        }, 300);
      });
    }
  }
};

export { mockPosts };
window.mockPostsApi = mockPostsApi;